import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface Template {
  assignment_template_id: string;
  status: string;
  check_id: string;
  case_id: string;
  template_version: number;
  check_name: string;
  assignment_id: string;
  is_required: boolean;
  display_order: number;
}

interface PackageState {
  assignment_id: string;
  case_id: string;
  case_number: string;
  package_id: string;
  package_name: string;
  status: string;
  templates: Template[];
  reloadPackage: number;
}

const initialState: PackageState = {
  assignment_id: "",
  case_id: "",
  case_number: "",
  package_id: "",
  package_name: "",
  status: "",
  templates: [],
  reloadPackage: 0,
};

const packageSlice = createSlice({
  name: "package",
  initialState,
  reducers: {
    setPackageData: (state, action: PayloadAction<any>) => {
      return {
        ...state,
        ...action.payload,
      };
    },

    triggerPackageReload: (state) => {
      state.reloadPackage += 1;
    },

    clearPackageData: () => initialState,
  },
});

export const { setPackageData, clearPackageData, triggerPackageReload } =
  packageSlice.actions;

export default packageSlice.reducer;
